<template>
    <div class="w-100 d-flex justify-content-center">
        <div id="pagenotfound" class="w-50 page-content text-center">
            <div class="page-title">
                <h2 class="display-2">Page Not Found</h2>
            </div>
            <div class="page-body">
                <h6 class="display-6">Sorry, the page you are looking for does not exist.</h6>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
#pagenotfound {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 85vh;
    width: 100%;
}
</style>